import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import PasswordUpdateValidator from '../../validators/PasswordUpdateValidator'
import InputField from '../Inputs/InputField'
import {sections} from '../../utils/variables'
import {withRouter} from 'react-router-dom'

class PageForm extends Component {

    constructor(props) {
	super(props);

	this.state = {
	    waiting: false,
	    status: undefined
	}
    }
    
    componentDidMount(){


    }
    
    render() {
	const { handleSubmit, successAction } = this.props
	let {waiting, status} = this.state;

	const submit = (values, dispatch, props) => {
	    let errors = PasswordUpdateValidator( values, props ) || {};
	    
	    waiting=true;
	    this.setState({ waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {
		
		values.token = props.computedMatch.params.token
		
		props.passwordUpdate(values).then((res) => {
		    waiting=false;
		    status='updated'
		    this.setState({ status,waiting})
		}).catch((err) => {	
		    waiting = false;
		    status='error'
		    this.setState({status, waiting})
		})
	    }
	}

	
	return (
	    <div style={{maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto'}}>
		<h1>Nova password</h1>
		{status == 'updated' ?
		 <h3>Password je bila spremenjena, sedaj lahko naredis login z novo password</h3>
		 :
		 <form onSubmit={handleSubmit(submit)}>
		     {status == 'error' ?
		      <h2 style={{color: 'red'}}>Nekaj ni vredu</h2>
		      :
		      ''
		     }
		     
		     <InputField name="password" type="password" label="Password" />
		     <InputField name="passwordConfirm" type="password" label="Ponovi password" />

		     <button type="submit" disabled={this.props.invalid} className="btn btn-brown btn-big full-width"><i style={{display: (this.state.waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i> Spremeni geslo</button>
		 </form>
		}
	    </div> 
	    
	);
    }
}

export default withRouter(reduxForm({
    form: 'page',
    validate: PasswordUpdateValidator,
    enableReinitialize: true
})(PageForm));



// WEBPACK FOOTER //
// ./src/components/PasswordUpdate/index.jsx